import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = ["id", "value", "checked"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass('inventaire__left__accord-checkbox inventaire__left__accord-checkbox-color ' + _ctx.group + '-group-item')
  }, [
    _createElementVNode("label", {
      for: _ctx.id,
      class: _normalizeClass([_ctx.isChecked === true ? 'inventaire__left__accord-checkbox-bold' : ''])
    }, [
      _createElementVNode("input", {
        type: "checkbox",
        id: _ctx.id,
        class: _normalizeClass('color color__'+ _ctx.name.toLowerCase()),
        value: _ctx.value,
        checked: _ctx.isChecked === true,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleClass()))
      }, null, 10, _hoisted_2),
      _createTextVNode(" " + _toDisplayString(_ctx.value), 1)
    ], 10, _hoisted_1)
  ], 2))
}